import { useState, useMemo } from 'react';

import {
	BsKanban,
	BsRadioactive,
	BsListNested,
	BsPlug,
	BsStars,
	BsTelephoneOutbound,
	BsCloudUpload,
	BsTags,
} from 'react-icons/bs';

import Page from '#globalComponents/Page/Page';
import PageHeader from '#globalComponents/PageHeader/PageHeader';
import Tabs from '#globalComponents/Tabs/Tabs';
import { useAuth } from '#globalContexts/AuthProvider';

import CrmSearchBar from '../../components/common/CrmSearchBar/CrmSearchBar';

import AiSettingsTab from './tabs/AiSettingsTab';
import CallingSettingsTab from './tabs/CallingSettingsTab';
import ChannelsSettingsTab from './tabs/ChannelsSettingsTab';
import CustomFieldsSettingsTab from './tabs/CustomFieldsSettingsTab';
import ImportSettingsTab from './tabs/ImportSettingsTab';
import IntegrationsSettingsTab from './tabs/IntegrationsSettingsTab';
import PipelinesSettingsTab from './tabs/PipelinesSettingsTab';
import TagsSettingsTab from './tabs/TagsSettingsTab';

/**
 * Settings page with in-page tabs. Channels tab is admin/owner-only.
 */

const CrmSettingsPage = () => {
	const { orgRole } = useAuth();
	const isAdmin = orgRole === 'owner' || orgRole === 'admin';

	const TABS = useMemo(
		() => [
			{ key: 'pipelines', label: 'Pipelines', icon: BsKanban, Component: PipelinesSettingsTab },
			...(isAdmin
				? [{ key: 'channels', label: 'Kanäle', icon: BsRadioactive, Component: ChannelsSettingsTab }]
				: []),
			...(isAdmin
				? [{ key: 'integrations', label: 'Integrationen', icon: BsPlug, Component: IntegrationsSettingsTab }]
				: []),
			{ key: 'fields', label: 'Eigene Felder', icon: BsListNested, Component: CustomFieldsSettingsTab },
			{ key: 'tags', label: 'Tags', icon: BsTags, Component: TagsSettingsTab },
			{ key: 'calling', label: 'Anrufe', icon: BsTelephoneOutbound, Component: CallingSettingsTab },
			{ key: 'ai', label: 'KI', icon: BsStars, Component: AiSettingsTab },
			{ key: 'import', label: 'Import', icon: BsCloudUpload, Component: ImportSettingsTab },
		],
		[isAdmin],
	);

	const [activeKey, setActiveKey] = useState('pipelines');
	const ActiveTab = TABS.find((t) => t.key === activeKey)?.Component ?? PipelinesSettingsTab;

	return (
		<Page
			header={
				<PageHeader breadcrumbs={[{ label: 'CRM', to: '/crm' }, 'Einstellungen']}>
					<div className="w-64">
						<CrmSearchBar />
					</div>
				</PageHeader>
			}
		>
			<Tabs
				tabs={TABS.map(({ key, label, icon }) => ({ id: key, label, icon }))}
				activeId={activeKey}
				onChange={setActiveKey}
				className="mb-6"
			/>

			<div className="pb-6 max-w-5xl">
				<ActiveTab />
			</div>
		</Page>
	);
};

export default CrmSettingsPage;
